import Ajv from 'ajv';
import ImageOverlaySchema from './ImageOverlaySchema';

class ImageOverlayModel {
  constructor(data, selectedPhotoID, isLoopy) {

    this.errors = null;

    this.ajv = new Ajv({ useDefaults: 'empty' });
    this.validateData(data);
    this.ajv = null;
    // console.log(this.errors);

    this.selected = null;
    this.totalImages = 0;
    this.values = [];

    if (this.errors) {
      this.selected = { value: null, next: null, previous: null };
      return;
    }

    const { Results } = data;

    this.map = Results.reduce((acc, review) => {
      review.Photos.forEach((photo) => {
        acc[photo.Id] = { value: { review, photo } };
        this.values.push(acc[photo.Id]);
      });
      return acc;
    }, {});

    const tail = this.values.reduce((acc, node, index) => {
      const currentNode = node;
      currentNode.previous = acc;
      currentNode.value.i = index;
      return currentNode;
    }, null);

    const head = this.values.reduceRight((acc, node, index) => {
      const currentNode = node;
      currentNode.next = acc;
      return currentNode;
    });

    if (isLoopy === true) {
      tail.next = head;
      head.previous = tail;
    }

    this.totalImages = this.values.length;

    if (!this.selectImageByID(selectedPhotoID)) {
      this.selectImageByID(this.values[0].value.photo.Id);
    }

  }

  selectImageByID(id) {
    if (!this.errors && this.map[id]) {
      this.selected = this.map[id];
      return this.selected.value;
    }

    return null;
  }

  selectImageByNode(node) {
    if (!this.errors) {
      this.selected = node;
      return this.selected.value;
    }
    return null;
  }

  selectNextImage() {
    return !this.errors && this.selected.next
      ? this.selectImageByNode(this.selected.next)
      : null;
  }

  selectPreviousImage() {
    return !this.errors && this.selected.previous
      ? this.selectImageByNode(this.selected.previous)
      : null;
  }

  hasNextImage() {
    return !this.errors && !!this.selected.next;
  }

  hasPreviousImage() {
    return !this.errors && !!this.selected.previous;
  }

  // eslint-disable-next-line class-methods-use-this
  validateData(data) {
    const valid = this.ajv.validate(ImageOverlaySchema, data);
    if (!valid) this.errors = this.ajv.errors;
  }

}

export default ImageOverlayModel;
